import { mdiCog } from '@mdi/js';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import * as S from './settings-button.styles';

export interface ISettingsButtonProps {
    to?: string;
}

const SettingsButtonComponent: React.FC<ISettingsButtonProps> = (props) => {
    const { accountId } = useParams<{ accountId?: string }>();
    const defaultTo = accountId ? `/${accountId}/settings` : '/settings';
    const to = props.to || defaultTo;
    
    return (
        <S.NavLink to={to}>
            {(linkProps): React.ReactElement => (
                <S.StyledButton variant="fab-light">
                    <S.StyledIcon path={mdiCog} />
                </S.StyledButton>
            )}
        </S.NavLink>
    );
};

export class SettingsButton extends React.PureComponent<ISettingsButtonProps> {
    public render(): React.ReactElement {
        return <SettingsButtonComponent {...this.props} />;
    }
}
